import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-all-industry-map',
  templateUrl: './all-industry-map.component.html',
  styleUrls: ['./all-industry-map.component.css']
})
export class AllIndustryMapComponent implements OnInit {

  title: string = '';

  centerLat: number = 20.5937;
  centerLng: number = 77.1025;
  stateLat: number = 20.5937;
  stateLng: number = 77.1025;

  zoom:number = 7;
  infoWindowOpened = null;
  radiusSearch = false;
  previous_info_window = null;
  public state: string = environment.state;
  route:string;
  industriesLocation = [];
  ocmmsApplicationList = [];
  mapLoader = false;

  searchField = {
    'name':'',
    'ocmms_id':'',
    'status':''
  };
  vendor_id = 0;
  userData:any = [];
  userName = null;
  userLevel = null;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];

      if(this.userLevel == 'vendor'){
        this.vendor_id = this.userData['id'];
      }
    }

    if(this.state == 'Bihar'){
      this.centerLat = 25.5941;
      this.centerLng = 85.1376;
      this.stateLat = 25.5941;
      this.stateLng = 85.1376;
    }else if(this.state == 'Haryana'){
      this.centerLat = 29.0588;
      this.centerLng = 76.0856;
      this.stateLat = 29.0588;
      this.stateLng = 76.0856;
    }else if(this.state == 'Delhi'){
      this.centerLat = 28.7041;
      this.centerLng = 77.1025;
      this.stateLat = 28.7041;
      this.stateLng = 77.1025;
    }else if(this.state == 'Punjab'){
        this.centerLat = 31.1471;
        this.centerLng = 75.3412;
        this.stateLat = 31.1471;
        this.stateLng = 75.3412;
    } else{
      this.centerLat = 20.5937;
      this.centerLng = 78.9629;
      this.stateLat = 20.5937;
      this.stateLng = 78.9629;
    }

    this.getIndustryLocations();
  }

  resetFilter(){
    this.searchField = {'name':'','ocmms_id':'','status':''};
    this.getIndustryLocations();
  }

  close_window(){

    if (this.previous_info_window != null ) {
      this.previous_info_window.close()
    }
  }

  select_marker(infoWindow){

    this.centerLat = infoWindow.hostMarker.latitude;
    this.centerLng = infoWindow.hostMarker.longitude;

    if (this.previous_info_window == null) {
      this.previous_info_window = infoWindow;
    }else{
      this.infoWindowOpened = infoWindow;
      this.previous_info_window.close();
      this.previous_info_window = infoWindow;
    }

  }

  getIndustryLocations(){

    this.centerLat = 0;
    this.centerLng = 0;
    this.zoom = 0;

    setTimeout(()=>{
      this.centerLat = this.stateLat;
      this.centerLng = this.stateLng;
      this.zoom = 7;
    },100);

    this.mapLoader = true;
    this.route  = 'get-all-industry-location';
    const token    = localStorage.getItem('userToken');
    this.industriesLocation = [];

    let data = {};

    if(this.userLevel == 'vendor'){
      data = {'user_id':this.userName,'user_level':this.userLevel, 'vendor_id':this.vendor_id, 'filter':this.searchField};
    }else {
      data = {'user_id':this.userName ,'user_level':this.userLevel, 'filter':this.searchField};
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      // if(response.status == 204) {
      //   localStorage.removeItem('userToken');
      //   localStorage.removeItem('userData');
      //   this.router.navigate(['login']);
      //   // location.reload();
      // }
      if(response.status == 200){
        this.industriesLocation = response.data;
        this.ocmmsApplicationList = response.applicationLists;
        console.log(this.industriesLocation);
        console.log(this.ocmmsApplicationList);
      }

      this.mapLoader = false;
//new_ppcpcb
    });

  }

}
